import { html } from 'lit';

import { AdVendor } from '@client/core/AdVendor';
import {
  AdnPlacement,
  AdServer,
  PlacementId
} from '@schibsted-nmp/advertising-shared';
import { renderDisplayAd } from '@client/core/batchRequesting/renderDisplayAd';
import { setupBatchRequestingForVendor } from '@client/core/batchRequesting/setupBatchRequestingForAdVendor';
import { $config } from '@client/core/atoms/config';

export class AdnAdVendor extends AdVendor {
  placementId: PlacementId;

  constructor(placementId: PlacementId) {
    super();
    this.adServer = AdServer.Adn;
    this.placementId = placementId;
    this.containerId = `${placementId}--container`;
  }

  updated(): void {}

  cleanupEvents() {}

  setupEvents() {}

  requestAd(): void {
    renderDisplayAd({
      placementId: this.placementId,
      containerId: this.containerId || `${this.placementId}--container`
    });
  }

  render() {
    return html`
      <slot name="${`${this.placementId}--slot`}" id="${this.placementId}">
        >
        <div id="${this.placementId}"></div
      ></slot>
    `;
  }

  static setupBatchRequesting() {
    const requestAds = (placements: AdnPlacement[]) => {
      const adUnits = placements.map(({ placementId }) => ({
        auId:
          placements.find((placement) => placement.placementId === placementId)
            ?.adServer.config.auId ?? '',
        targetId: placementId,
        kv: $config.get().adServer.adn?.kv || []
      }));

      window.adn.calls.push(() => {
        window.adn.request({
          adUnits
        });
      });
    };

    setupBatchRequestingForVendor({
      adServer: AdServer.Adn,
      requestAds
    });
  }
}
